<template>
  <v-snackbar
    v-model="notificationStore.show.value"
    :color="notificationStore.type.value"
    :timeout="notificationStore.timeout.value"
    location="top"
    transition="slide-y-transition"
    multi-line
  >
    <span
      v-html="sanitizedMessage"
      :aria-live="notificationStore.type.value === 'error' ? 'assertive' : 'polite'"
      role="status"
    ></span>
    <template v-slot:actions v-if="notificationStore.closeable.value">
      <v-btn
        icon="fa-solid fa-xmark"
        variant="text"
        size="small"
        :aria-label="$t('a11y.closeNotification')"
        @click="notificationStore.show.value = false"
      >
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
import { computed } from 'vue';
import DOMPurify from 'dompurify';
import { notificationStore } from '../../stores/notification.js';

// Sanitize the notification message before binding via v-html to prevent XSS.
const sanitizedMessage = computed(() =>
  DOMPurify.sanitize(notificationStore.message.value ?? '')
);
</script>
